export const SELLERS_ACTIONS_TYPES = {
	SET_SELLERS: "sellers/SET_SELLERS",
	SET_TYPEDOCS: "sellers/SET_TYPEDOCS",
};
